import { Avatar, Box, Divider, Grid, makeStyles, Typography } from '@material-ui/core'
import { Label } from '@material-ui/icons';
import React, { useState } from 'react'
import CustomSelect from '../../../../Components/CustomSelect'

const useStyles = makeStyles((theme) => ({
    small: {
        width: theme.spacing(5),
        height: theme.spacing(5),
        margin: "0 auto"
    },
}));


function Feedback() {
    const classes = useStyles();
    const [userData, setUserData] = useState({
        givenBy: "",
        sessionScenario: "",
        sortBy: "",
    });

    const onChangeItem = (selectedItemValue) => {
        setUserData({ ...userData, [selectedItemValue.id]: selectedItemValue.value })
    };

    return (
        <Box p={3}>
            <Typography variant="h1">
                <Box mb={3} fontWeight="fontWeightBold">Feedback</Box>
            </Typography>
            <Grid container direction="row">
                <Grid item xs={8}>
                    <Grid container direction="row" spacing={2} >
                        <Grid item xs={4}>
                            <Typography variant="h2"><Box mb={1}>Given by</Box></Typography>
                            <CustomSelect id="givenBy" labelText="Coachee name" displayEmpty variant="outlined" itemArr={[1, 2, 3, 4]} parentcall={onChangeItem} defaultValue={userData.givenBy} />
                        </Grid>
                        <Grid item xs={4}>
                            <Typography variant="h2"><Box mb={1}>Session scenario</Box></Typography>
                            <CustomSelect id="sessionScenario" labelText="Choose session" displayEmpty variant="outlined" itemArr={[1, 2, 3, 4]} parentcall={onChangeItem} defaultValue={userData.sessionScenario} />
                        </Grid>
                        <Grid item xs={4}>
                            <Typography variant="h2"><Box mb={1}>Sort by</Box></Typography>
                            <CustomSelect id="sortBy" labelText="Most recent/6 months" displayEmpty variant="outlined" itemArr={[1, 2, 3, 4]} parentcall={onChangeItem} defaultValue={userData.sortBy} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Box mt={4}>
                {
                    [1, 2, 3, 5].map((option) => {
                        return <>
                            <Grid container direction="row" spacing={2} style={{ marginTop: 20 }}>
                                <Grid item xs={1}>
                                    <Box>
                                        <Avatar alt="Remy Sharp" src={""} className={classes.small} />
                                    </Box>
                                </Grid>
                                <Grid item xs={11}>

                                    <Typography variant="subtitle1">
                                        <Box fontWeight="fontWeightBold" mb={2}>Hellen Baumbach</Box>
                                    </Typography>
                                    <Typography variant="h2">
                                        <Box mb={2}>
                                            Nunc scelerisque tincidunt elit. Vestibulum non mi ipsum. Cras pretium suscipit tellus sit amet aliquet. Vestibulum maximus lacinia massa non porttitor. Pellentesque vehicula est a lorem gravida bibendum. Proin tristique diam ut urna pharetra, ac rhoncus elit elementum. Proin vitae purus ultrices, dignissim turpis ut, mattis eros. Maecenas ornare molestie urna, hendrerit venenatis sem.

                                        </Box>
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Divider />
                        </>
                    })
                }
            </Box>
        </Box>
    )
}

export default Feedback
